import React, { PureComponent } from 'react';
import NavLink from './NavLink';
import { SUPPORT_URL } from '../../constants/urls';

export default class SupportLink extends PureComponent {
  render() {
    const { className } = this.props;

    return (
      <NavLink
        className={className}
        href={SUPPORT_URL} page={null}
        id="supportLink"
        name="supportLink"
      >
        <span style={{ fontSize: 22 }}>
          <i className="fa fa-question-circle-o" aria-hidden="true" style={{ marginRight: 8 }}/>
        </span>
        Help
      </NavLink>
    );
  }
}